import { User } from "../user/User"
import { PurchaseOrderItemForDetails } from "./PurchaseOrderItemForDetails"

export class PurchaseOrderItemDetails {
  id: number
  canBeUsedToFulfillOrderPart: boolean
  displayOrder: number
  name: string
  price: number
  purchaseOrderItemFor?: PurchaseOrderItemForDetails
  receivedByUser?: User
  receivedDate?: string

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, canBeUsedToFulfillOrderPart: boolean, displayOrder: number, name: string, price: number, purchaseOrderItemFor: any, receivedByUser: any|undefined, receivedDate: string|undefined) {
    this.id = id
    this.canBeUsedToFulfillOrderPart = canBeUsedToFulfillOrderPart
    this.displayOrder = displayOrder
    this.name = name
    this.price = price
    this.purchaseOrderItemFor = purchaseOrderItemFor ? purchaseOrderItemFor as PurchaseOrderItemForDetails : undefined
    this.receivedByUser = receivedByUser ? new User(receivedByUser) : undefined
    this.receivedDate = receivedDate
  }
}
